<template>
  <th @click="e => $emit('handleClick', e)">
    <slot />
  </th>
</template>
